import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "gw-youtube",
  "use": "gw-youtube-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"gw-youtube\"><path fill=\"none\" d=\"M0 0h24v24H0Z\" /><path d=\"M21.582 7.2a2.51 2.51 0 0 0-1.768-1.78C18.254 5 12 5 12 5s-6.254 0-7.814.42A2.51 2.51 0 0 0 2.418 7.2C2 8.77 2 12.045 2 12.045s0 3.276.418 4.846c.23.866.908 1.52 1.768 1.75 1.56.421 7.814.421 7.814.421s6.254 0 7.814-.42a2.48 2.48 0 0 0 1.768-1.751C22 15.32 22 12.045 22 12.045s0-3.275-.418-4.845M9.955 15.02V9.071l5.227 2.974z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol